import  { useEffect, useState } from "react";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { hasPermission } from "../../../components/user-permission/AuthorizationParameter";
import useUserPermissions from "../../../components/user-permission/UserPermission";
const ViewParentRollReport = ({ parentRollDetails, parentRollNumber, shiftDate, selectedShiftCodes, machineCode, totalMOQty, totalLength }) => {
    const [parentRoll, setParentRoll] = useState([]);
    const userPermissions = useUserPermissions();

    useEffect(() => {
        if (parentRollDetails) {
            setParentRoll(parentRollDetails);
        }

    }, [parentRollDetails]);

    // Function to format the date to 'dd-mm-yyyy'
    const formatDate = (date) => {
        if (!date) return ''; // Return empty string if no date is provided
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0'); // Pad day with leading zero if needed
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const exportPDF = () => {
        const pdf = new jsPDF('l', 'mm', 'a4');
        const margin = 5;
        let currentY = margin;
        const pageWidth = pdf.internal.pageSize.getWidth();
        const tableWidth = 50; // Adjust table width as needed

        // Title
        pdf.setFontSize(18);
        currentY += 4;
        pdf.text('PARENT ROLL PLANNING REPORT', margin, currentY);
        currentY += 5;

        // ADD LINE
        pdf.setLineWidth(0.2); // Set the thickness of the line (optional)
        pdf.line(margin, currentY, pdf.internal.pageSize.getWidth() - margin, currentY); // Draw line across the page
        currentY += 5; // Adjust space after the line

        // MO Report Header
        pdf.setFontSize(10);
        pdf.text(`PARENT ROLL # : ${parentRollNumber ? parentRollNumber : 'N/A'} .`, margin, currentY);
        currentY += 5;

        pdf.text(`Shift Detail : ${selectedShiftCodes ? selectedShiftCodes : ''}, ${shiftDate ? formatDate(shiftDate) : ''} .`, margin, currentY);
        currentY += 5;

        pdf.text(`Paper machine : ${machineCode ? machineCode : ''} .`, margin, currentY);
        currentY += 5;

        // ADD LINE
        pdf.setLineWidth(0.2); // Set the thickness of the line (optional)
        pdf.line(margin, currentY, pdf.internal.pageSize.getWidth() - margin, currentY); // Draw line across the page
        currentY += 10; // Adjust space after the line

        // Combination Details Header
        pdf.setFontSize(14);
        pdf.text('PARENT ROLL DETAIL', margin, currentY);
        currentY += 5;

        pdf.setFontSize(14);

        // Check if `parentRoll` exists and is an array
        const body = parentRoll && Array.isArray(parentRoll) ? parentRoll.map((detail) => [
            detail.mono || 'N/A',
            detail.lotnumber || 'N/A',
            detail.gsm || 'N/A',
            detail.quality || 'N/A',
            detail.jumbowidth || 'N/A',
            detail.achieved_deckle || 'N/A',
            detail.reel_od || 'N/A',
            detail.reel_id || 'N/A',
            detail.noofsets || 'N/A',
            detail.qty? Number(detail.qty).toFixed(1) : 'N/A',
            detail.ma_qty || 'N/A',
            detail.reel_length || 'N/A',
            detail.combination || 'N/A',
            detail.winder_cut || 'N/A',
        ]) : []; // Fallback to empty array if `parentRoll` is undefined

        // Table for MO Details
        if (body.length > 0) {
            autoTable(pdf, {
                startY: currentY,
                head: [['MO NUMBER', 'MA NUMBER', 'GSM', 'QUALITY', 'JUMBO WIDTH', 'ACH DECKLE', 'REEL OD (CM)', 'CORE ID (Inch)', 'SETS', 'QTY (MT)', 'MA QTY (MT)', 'REEL LENGTH', 'COMBINATION', 'WINDER CUT', 'REMARKS']],
                body: body,
                theme: 'grid',
                styles: { fontSize: 6, fontFamily: 'cambria' },
                headStyles: { fillColor: [61, 73, 162], halign: 'center' },
                margin: { left: margin, right: margin },
            });

            currentY = pdf.previousAutoTable.finalY + 10;
        } else {
            pdf.text('No parent roll details available.', margin, currentY);
            currentY += 10;
        }

        // Summary of Output Table
        autoTable(pdf, {
            startY: currentY,
            body: [
                ['Total MO Qty :', totalMOQty || 'N/A'],
                ['Total Reel Length :', totalLength || 'N/A'],
            ],
            theme: 'grid',
            styles: { fontSize: 8, halign: 'left' },
            headStyles: { fillColor: [51, 59, 120], halign: 'center' },
            margin: { left: (pageWidth - tableWidth - margin), right: margin },
            width: tableWidth // Set the width of the table
        });

        currentY = pdf.previousAutoTable?.finalY + 5 || currentY;
        pdf.setFontSize(10);
        pdf.text('Authorised Signature: ________________________________________', margin, currentY);

        // Save the PDF
        pdf.save(`Parent Roll Report # ${parentRollNumber ? parentRollNumber : 'N/A'}.pdf`);
    };

    //th, td { border: 1px solid #000; padding: 5px; text-align: center; }
    
    const printdata = () => {
        const margin = '10px';
        const pageStyles = `
        <style>
            body { font-family: Cambria, serif; margin: 10px; padding: ${margin}; }
            h1 { font-size: 18px; margin: 5px 0; }
            h2 { font-size: 15px; margin: 10px 0; }
            p { font-size: 15px; margin: 3px 0; }
            table { width: 100%; border-collapse: collapse; margin: 10px 0; font-size: 15px; }
           th{ border: 1px solid #000; padding: 5px; text-align: center; }
            th { 
                background-color: rgb(253, 253, 253); 
                color: black; 
                text-align: center; 
                word-wrap: break-word; /* Ensures text wraps within headers */
                white-space: normal; /* Allows wrapping if text is too long */
            }
           
            .line { border-bottom: 1px solid #000; margin: 10px 0; }
        </style>
    `;

        let content = `
            ${pageStyles}
            <h1>PARENT ROLL PLANNING REPORT</h1>
            <div class="line"></div>
            <p><b>PARENT ROLL # :</b> ${parentRollNumber || 'N/A'}</p>
            <p><b>Shift Detail :</b> ${selectedShiftCodes || ''}, ${shiftDate ? formatDate(shiftDate) : ''}</p>
            <p><b>Paper Machine :</b> ${machineCode || 'N/A'}</p>
            <div class="line"></div>
            <h2>PARENT ROLL DETAIL</h2>
        `;
        // <th>JUMBO WIDTH</th>
        // Check if `parentRoll` exists and is an array
        if (parentRoll && Array.isArray(parentRoll) && parentRoll.length > 0) {
            content += `
                <table>
                    <thead>
                        <tr>
                            <th>MO#</th>
                            <th>MA#</th>
                            <th>GSM</th>
                            <th>QUALITY</th>                           
                            <th>ACH DECKLE</th>
                            <th>OD (CM)</th>
                            <th>ID (inch)</th>
                            <th>SETS</th>
                            <th>QTY (MT)</th>
                            <th>MA QTY (MT)</th>
                            <th>LENGTH (Mtrs)</th>
                            <th>COMBINATION / WINDER CUT</th>                           
                            <th>REMARKS</th>
                        </tr>
                    </thead>
                    <tbody>
            `;
            // <td>${detail.jumbowidth || 'N/A'}</td> <th>WINDER CUT</th>
            parentRoll.forEach(detail => {
                const fontSize = detail.combination.split("+").length > 6 ? "15px" :
                    detail.combination.includes("+") ? "15px" : "inherit";  // Adjust font size if more than one value

                let fontSizeRemark = "15px"; // Use let to allow reassignment
                if (detail.remarks && typeof detail.remarks === 'string') { // Ensure remarks is not null/undefined and is a string
                    fontSizeRemark = detail.remarks.split(" ").length > 4
                        ? "10px"
                        : detail.remarks.includes(" ")
                            ? "15px"
                            : "inherit"; // Adjust font size if more than one value
                }


                content += `
                            <tr>
                                <td style=" border: 1px solid #000; padding: 5px; text-align: center;">${detail.mono || 'N/A'}</td>
                                <td style=" border: 1px solid #000; padding: 5px; text-align: center;">${detail.lotnumber || 'N/A'}</td>
                                <td style=" border: 1px solid #000; padding: 5px; text-align: center;">${detail.gsm || 'N/A'}</td>
                                <td style=" border: 1px solid #000; padding: 5px; text-align: center;">${detail.quality || 'N/A'}</td>
                                <td style=" border: 1px solid #000; padding: 5px; text-align: center;">${detail.achieved_deckle || 'N/A'}</td>
                                <td style=" border: 1px solid #000; padding: 5px; text-align: center;">${detail.reel_od || 'N/A'}</td>
                                <td style=" border: 1px solid #000; padding: 5px; text-align: center;">${detail.reel_id || 'N/A'}</td>
                                <td style=" border: 1px solid #000; padding: 5px; text-align: center;">${detail.noofsets || 'N/A'}</td>
                                <td style=" border: 1px solid #000; padding: 5px; text-align: center;">${detail.qty ? Number(detail.qty).toFixed(1) : 'N/A'}</td>
                                <td style=" border: 1px solid #000; padding: 5px; text-align: center;">${detail.ma_qty || 'N/A'}</td>
                                <td style=" border: 1px solid #000; padding: 5px; text-align: center;">${detail.reel_length || 'N/A'}</td>
                                <td style=" border: 1px solid #000; padding: 5px; text-align: center;">
                                    <table style="width: 100%; border-collapse: collapse; margin-bottom: 0;">
                                        <tbody>
                                            <tr>
                                                <td style="border-bottom: 0.2px groove black; padding: 5px; text-align: center;font-size: ${fontSize};">
                                                    ${detail.combination || 'N/A'}
                                                </td>
                                               
                                            </tr>
                                            <tr>
                                                <td style="font-size: 40px;
                                                    font-weight: bold; 
                                                    text-align: center;
                                                    word-wrap: break-word; 
                                                    white-space: normal;">
                                                    ${detail.winder_cut || 'N/A'}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                                <td style="border: 1px solid #000; padding: 5px; text-align: center;font-size: ${fontSizeRemark};">${detail.remarks || ''}</td>
                            </tr>
                            `;

            
            });
            // 
            content += `
                    </tbody>
                </table>
            `;
        } else {
            content += `<p>No parent roll details available.</p>`;
        }

        // Summary of Output Table
        content += `
            <h2>Summary</h2>
            <table style="width: 20%;">
                <tbody>
                    <tr>
                        <td  style=" border: 1px solid #000; padding: 5px; text-align: center;">Total MO Qty :</td>
                        <td  style=" border: 1px solid #000; padding: 5px; text-align: center;">${totalMOQty || 'N/A'}</td>
                    </tr>
                    <tr>
                        <td  style=" border: 1px solid #000; padding: 5px; text-align: center;">Total Reel Length :</td>
                        <td  style=" border: 1px solid #000; padding: 5px; text-align: center;">${totalLength || 'N/A'}</td>
                    </tr>
                </tbody>
            </table>
            <p>Authorised Signature: ________________________________________</p>
        `;

        // Open a new window and print
        const printWindow = window.open('', '_blank');
        printWindow.document.write(content);
        printWindow.document.close();
        printWindow.print();
    };

    // <td>
    // <table style="width: 100%; border: 0px solid #000; padding: 5px; text-align: center;">
    //                 <tbody >
    //                     <tr>                                               
    //                        <td style="font-size: ${fontSize}; ">${detail.combination || 'N/A'}</td>
    //                     </tr>
    //                     <tr>                                                
    //                         <td style="font-size: 40px;
    //                             font-weight: bold; 
    //                             word-wrap: break-word; 
    //                             white-space: normal;">
    //                             ${detail.winder_cut || 'N/A'}
    //                         </td>
    //                     </tr>
    //                 </tbody>
    //             </table>
    // </td>


    return (
        <div style={{ padding: '20pt', fontFamily: 'cambria', fontSize: '12px', color: 'black', backgroundColor: 'white' }}>
            <h1>PARENT ROLL PLANNING REPORT


                {hasPermission(userPermissions, "Paper Machine Production", "Print") && (
                    <div style={{ marginRight: 'auto' }}>
                        <button onClick={exportPDF} >Download PDF</button>
                        <button style={{ marginLeft: "10px" }} onClick={printdata} >Print</button>
                    </div>

                )}

            </h1>
            <hr />
            {/* onClick={exportPDF} */}

            <div id="report" style={{ padding: '1px', backgroundColor: '#fff', color: '#000' }}>

                <div>
                    <div id="report" style={{ padding: '0px', backgroundColor: '#fff', color: '#000', marginBottom: '10px' }}>
                        {/* <h2>MO Report</h2> */}
                        <p>PARENT ROLL # : {`${parentRollNumber ? parentRollNumber : ''}`}  </p>
                        <p>{`Shift code : ${selectedShiftCodes ? selectedShiftCodes : ''}, Shift date:${shiftDate ? formatDate(shiftDate) : ''}`}</p>
                        <p>{`Paper machine : ${machineCode ? machineCode : ''}`}</p>
                        {/* <p>Booked by : ARUN</p> */}

                        <hr />
                        <h3>PARENT ROLL DETAIL</h3>

                    </div>
                </div>
                {parentRoll.length > 0 && (
                    <>

                        <div style={{ marginBottom: '20px', pageBreakAfter: 'always' }}>

                            <div style={{ width: '100%' }}>

                                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '0px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '130px' }}>MO #</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '80px' }}>MA #</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '70px' }}>GSM</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '150px' }}>QUALITY</th>

                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '100px' }}>ACH DECKLE</th>
                                            <th style={{ border: '0.2px groove black', padding: '5px', width: '60px' }}>OD (CM)</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '60px' }}>ID (Inch)</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '60px' }}>SETS</th>
                                            <th style={{ border: '0.2px groove black', padding: '5px', width: '110px' }}>QTY (MT)</th>
                                            <th style={{ border: '0.2px groove black', padding: '5px', width: '130px' }}>MA QTY(MT)</th>
                                            <th style={{ border: '0.2px groove black', padding: '5px', width: '130px' }}>LENGTH</th>
                                            <th style={{ border: '0.2px groove black', padding: '5px', width: '130px' }}>COMBINATION / WINDER CUT</th>
                                            {/* <th style={{ border: '0.2px groove black', padding: '5px', width: '130px' }}>WINDER CUT</th> */}
                                            <th style={{ border: '0.2px groove black', padding: '5px', width: '130px' }}>REMARKS</th>
                                        </tr>
                                    </thead>
                                    {parentRoll.map((mo, index) => (
                                        <tbody key={index}>

                                            <tr>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> {mo.mono} </td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{mo.lotnumber}</td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{mo.gsm}</td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> {mo.quality}</td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> {mo.achieved_deckle}</td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> {mo.reel_od}</td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{mo.reel_id}</td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> {mo.noofsets}</td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{mo.qty ? Number(mo.qty).toFixed(1) : 'N/A'}</td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> {mo.ma_qty}</td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> {mo.reel_length}</td>
                                                <table style={{ width: '100%', borderCollapse: 'collapse', border: 'none', marginBottom: '0px' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ borderBottom: '0.2px groove black', padding: '5px', textAlign: 'center' }}> {mo.combination}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ borderBottom: '0.2px groove black',fontSize:'30px', padding: '5px', textAlign: 'center' }}> {mo.winder_cut}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>



                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> {mo.remarks}</td>
                                            </tr>
                                        </tbody>
                                    ))}
                                </table>
                            </div>
                        </div>

                    </>
                )}




                <h3>Summary of Output</h3>
                <p>Total MO Quantity :{totalMOQty} </p>
                <p>Total Reel Length :{totalLength}</p>
                {/* <p>Total Sets: 0</p> */}
                <p>Authorised Signature: ________________________________________</p>

            </div>

        </div>
    );
}
export default ViewParentRollReport;